/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reject_ReportInputs */

const en_reject_report = /** @type {(inputs: Reject_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject`)
};

const id_reject_report = /** @type {(inputs: Reject_ReportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tolak`)
};

/** @type {(inputs: Reject_ReportInputs) => LocalizedString} */
const es_reject_report = en_reject_report;

/** @type {(inputs: Reject_ReportInputs) => LocalizedString} */
const fr_reject_report = en_reject_report;

/** @type {(inputs: Reject_ReportInputs) => LocalizedString} */
const de_reject_report = en_reject_report;

/** @type {(inputs: Reject_ReportInputs) => LocalizedString} */
const ja_reject_report = en_reject_report;

/** @type {(inputs: Reject_ReportInputs) => LocalizedString} */
const zh_reject_report = en_reject_report;

/** @type {(inputs: Reject_ReportInputs) => LocalizedString} */
const ar_reject_report = en_reject_report;

/** @type {(inputs: Reject_ReportInputs) => LocalizedString} */
const it_reject_report = en_reject_report;

/** @type {(inputs: Reject_ReportInputs) => LocalizedString} */
const ru_reject_report = en_reject_report;

/** @type {(inputs: Reject_ReportInputs) => LocalizedString} */
const pt_reject_report = en_reject_report;

/** @type {(inputs: Reject_ReportInputs) => LocalizedString} */
const ko_reject_report = en_reject_report;

/**
* | output |
* | --- |
* | "Reject" |
*
* @param {Reject_ReportInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const reject_report = /** @type {((inputs?: Reject_ReportInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reject_ReportInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reject_report(inputs)
	if (locale === "es") return es_reject_report(inputs)
	if (locale === "fr") return fr_reject_report(inputs)
	if (locale === "de") return de_reject_report(inputs)
	if (locale === "ja") return ja_reject_report(inputs)
	if (locale === "zh") return zh_reject_report(inputs)
	if (locale === "ar") return ar_reject_report(inputs)
	if (locale === "id") return id_reject_report(inputs)
	if (locale === "it") return it_reject_report(inputs)
	if (locale === "ru") return ru_reject_report(inputs)
	if (locale === "pt") return pt_reject_report(inputs)
	return ko_reject_report(inputs)
});